import { TableViewStore, BaseListViewStore } from 'core/stores';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { applicationContext, subCategoriesSort, uuid } from 'core/utils';
import { BaasicButton } from 'core/components';
import { LookupService } from "common/services";
import { ItemSubcategoryService } from "application/facility-order/services";
import { action, observable, runInAction } from 'mobx';
import React from "react";
import _ from 'lodash';

@applicationContext
class ProductOrderingListViewStore extends BaseListViewStore {
    @observable accessor tabItems = [];
    @observable accessor selectedStatusAbrv = "";

    constructor(rootStore) {
        const lookupService = new LookupService(rootStore.application.baasic.apiClient);
        const itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'product-ordering',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {},
            actions: () => {
                return {
                    find: async (params) => {
                        this.lookups = await lookupService.getLookups("SubCategory");
                        let data = subCategoriesSort(this.lookups.subCategory.map(i => { return { ...i, name: `${i.name}` } }));
                        const subCategorysAbrv = ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube", "Urologicals", "Ostomy-Products", "Wound-Care"];
                        const nextTabItems = _.filter(data, i => { return subCategorysAbrv.some(s => i.abrv === s); });
                        const nextSelectedStatusAbrv = _.find(nextTabItems, s => {
                            return params && params.subCategoryId ? s.id === params.subCategoryId : s.abrv === 'Enteral';
                        }).abrv;
                        runInAction(() => {
                            this.tabItems = nextTabItems;
                            this.selectedStatusAbrv = nextSelectedStatusAbrv;
                        });
                        const subCategoryId = _.find(this.lookups.subCategory, s => { return s.abrv === nextSelectedStatusAbrv }).id;

                        var pageNumber = this.setPage ? parseInt(this.rootStore.routerStore.routerState.queryParams.page) : params.pageNumber;
                        this.setPage = false;
                        this.rootStore.routerStore.routerState.queryParams.page = pageNumber;

                        var response = await itemSubcategoryService.find({ ...params, pageNumber: pageNumber, subCategoryId: subCategoryId, embed: 'Product' });
                        var productsOrderingSort = await itemSubcategoryService.find({ rpp: 10000, subCategoryId: subCategoryId, fields: "Id,ProductId,SubCategoryId,Sort" });
                        this.productsOrdering = productsOrderingSort.data.item;
                        return response.data;
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'product.itemId',
                    title: 'ItemId',
                    sortable: false
                },
                {
                    key: 'product.description',
                    title: 'Item Name',
                    sortable: false
                },
                {
                    key: 'sort',
                    title: 'Sort',
                    cell: (item) => {
                        return (
                            <td>
                                <div className="u-flex--primary u-flex--no-wrap" key={uuid()}>
                                    <input
                                        className="input input--sml input--table u-mar--right--tny"
                                        onClick={(e) => e.target.select()}
                                        onBlur={(e) => {
                                            this.updateItem(item.dataItem, null, e.target.value)
                                        }}
                                        defaultValue={item.dataItem.sort}
                                        min="1"
                                        type="integer"
                                    />

                                    <div className="table__icons">
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--arrow-up u-icon--sml"
                                            label="Up"
                                            onlyIcon={true}
                                            onClick={() => { this.updateItem(item.dataItem, 'up') }}
                                        ></BaasicButton>
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--arrow-down u-icon--sml"
                                            label="Down"
                                            onlyIcon={true}
                                            onClick={() => { this.updateItem(item.dataItem, 'down') }}
                                        ></BaasicButton>
                                    </div>
                                </div>
                            </td >
                        )
                    }
                }
            ]),
            actions: {
                onDelete: async (item) => this.deleteResource(item)
            }
        }));

        this.itemSubcategoryService = itemSubcategoryService;
    }

    @action.bound
    async setStatus(statusAbrv) {
        const statusId = _.find(this.lookups.subCategory, s => { return s.abrv === statusAbrv; }).id;
        this.queryUtility.filter.set('subCategoryId', statusId);
        this.queryUtility.fetch();
    }

    @action.bound
    getProductsOrderingDownloadUrl() {
        const parameters = this.queryUtility.plainFilter;
        parameters.sort = "subcategory|asc";
        const downloadProductsOrderingUrl = `${this.itemSubcategoryService.getDownloadUrl({ ...parameters })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`
        window.open(downloadProductsOrderingUrl, "_blank");
    }

    @action.bound
    uploadProductsOrdering() {
        this.rootStore.routerStore.goTo('master.app.main.product.order-upload');
    }

    @action.bound
    createNewProductOrdering() {
        this.rootStore.routerStore.goTo('master.app.main.product-ordering.create');
    }

    @action.bound
    async updateItem(item, direction, value) {
        let swapItem = null;
        if (direction) {
            if (!item.sort) {
                const numbers = _.map(this.productsOrdering.filter(po => po.sort), (po) => { return po.sort });
                item.sort = numbers.length > 0 ? Math.max(...numbers) + 1 : 1;
            }
            else {
                var index = this.productsOrdering.findIndex(p => p.id === item.id);
                if (direction === 'up') {
                    if (item.sort === 1 || !this.productsOrdering[index - 1]) {
                        return;
                    }
                    else {
                        item = this.productsOrdering[index];
                        const temp = this.productsOrdering[index - 1].sort;
                        this.productsOrdering[index - 1].sort = item.sort;
                        item.sort = temp;
                        swapItem = this.productsOrdering[index - 1];
                    }
                }
                else {
                    if (this.productsOrdering[index + 1] && this.productsOrdering[index + 1].sort) {
                        item = this.productsOrdering[index];
                        const temp = this.productsOrdering[index + 1].sort;
                        this.productsOrdering[index + 1].sort = item.sort;
                        item.sort = temp;
                        swapItem = this.productsOrdering[index + 1];
                    }else{
                        return;
                    }
                }
            }

            this.updateResource(item, swapItem);
        } 
        else {
            if (value && parseInt(value) < 1) {
                value = 1;
            }

            if(!this.productsOrdering.some(p => p.sort == value && p.id !== item.id)){
                item.sort = value;
                this.updateResource(item, swapItem, true);
            }else{
                this.rootStore.modalStore.showConfirm(
                    `A product already exists with sort number ${value}, do you want to replace and it readjust all subsequent sort number?`,
                    async () => {
                        item.sort = value;
                        this.updateResource(item, swapItem, true);
                    }
                );
            }
        }
    }

    @action.bound
    async updateResource(item, swapItem, replace = false) {
        let items = swapItem ? [{...item, replace: replace}, {...swapItem, replace: replace}] : [{...item, replace: replace}];

        try{
            await this.itemSubcategoryService.batchUpdate(items);
        }
        catch(err) {
            this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : 'Error occured while trying to update the products ordering.');
        }

        this.queryUtility.filter.set("page", parseInt(this.rootStore.routerStore.routerState.queryParams.page));
        this.setPage = true;
        this.queryUtility.fetch();
    }

    @action.bound
    async deleteResource(item) {
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            'PRODUCT_ORDERING.DELETE.CONFIRM',
            async () => {
                try {
                    await this.itemSubcategoryService.delete(item);
                    notificationStore.success('PRODUCT_ORDERING.DELETE.SUCCESS');
                    this.queryUtility.filter.set("page", parseInt(this.rootStore.routerStore.routerState.queryParams.page));
                    this.setPage = true;
                    await this.queryUtility.fetch();
                } catch (err) {
                    notificationStore.error('LIST_LAYOUT.ERROR_DELETE', err);
                }
            }
        );
    }
}

export default ProductOrderingListViewStore;
